import { render, staticRenderFns } from "./commonDiseaseBottomCard.vue?vue&type=template&id=42d452c2&scoped=true&"
import script from "./commonDiseaseBottomCard.vue?vue&type=script&lang=js&"
export * from "./commonDiseaseBottomCard.vue?vue&type=script&lang=js&"
import style0 from "./commonDiseaseBottomCard.vue?vue&type=style&index=0&id=42d452c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d452c2",
  null
  
)

export default component.exports